import { ActionTree } from 'vuex';
import axios from 'axios';
import { RootState } from '@/store/types';
import {ServiceProviderFilter, ServiceProviderItem, ServiceProvidersState} from './types';
import {directDownload} from "@/utils/download-helper";

export const actions: ActionTree<ServiceProvidersState, RootState> ={
  getServiceProviders: ({commit, dispatch},data) => {
    return new Promise((resolve, reject) => {
      axios({url: '/acapi/service_providers',params: {
          id: data?.id,
          name: data?.name,
          transports: Array.isArray(data?.transport) ? data?.transport?.join() : data?.transport,
          status: data?.status,
          protocols: data?.protocols,
          page_number: data?.page_number,
          page_size: data?.page_size,
          order_by: data?.order_by,
          order_direction: data?.order_direction,
          query: data?.query
        }})
          .then(resp => {
              if (data?.page_number > 1) {
                  commit("pushServiceProviders", resp.data.service_providers);
              } else {
                  commit('setServiceProviders', resp.data.service_providers);
              }
            resolve(resp.data.service_providers)
          })
          .catch(err => {
            reject(err)
          })
          .finally(() => commit('setLoading', false))
    })
  },
  getServiceProviderItem: ({commit, dispatch},id) => {
    commit('setLoading', true);
    return new Promise((resolve, reject) => {
      axios({url: `/acapi/service_providers/${id}`})
        .then((resp:any) => {
          let serviceProviderItem = <ServiceProviderItem>resp.data;
          serviceProviderItem.id = id;
          commit('setServiceProviderItem', serviceProviderItem);
          resolve(serviceProviderItem)
        })
        .catch(err => {
          reject(err)
        })
        .finally(() => commit('setLoading', false))
    })
  },
  saveServiceProvider: ({commit, dispatch}, data:ServiceProviderItem) => {
    commit('setLoading', true);
    return new Promise((resolve, reject) => {
      axios({
        method: data.id ? 'put' : 'post',
        url: '/acapi/service_providers/' + (data.id ?? ''),
        data: data
      })
        .then((resp:any) => {
          console.log(resp.data);
          dispatch('getServiceProviders');
          resolve(resp)
        })
        .catch((err:any) => {
          // errorNotify(err);
          reject(err)
        })
        .finally(() => commit('setLoading', false))
    })
  },
  deleteServiceProvider: ({commit, dispatch}, data: ServiceProviderItem) => {
    commit('setLoading', true);
    return new Promise((resolve, reject) => {
      axios({
        method: 'delete',
        url: `/acapi/service_providers/${data.id}`,
        data: data
      })
        .then((resp:any) => {
          dispatch('getServiceProviders');
          resolve(resp)
        })
        .catch((err:any) => {
          reject(err)
        })
        .finally(() => commit('setLoading', false))
    })
  },
  exportServiceProviders: ({commit, dispatch}, data: ServiceProviderFilter) => {
    const preparedFilter = {
      id: data?.id,
      name: data?.name,
      transports: Array.isArray(data?.transport) ? data?.transport?.join() : data?.transport,
      status: data?.status,
    }
    return directDownload('/acapi/service_providers/export', preparedFilter)
  }
};
